import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";

export const BUTTON_THEME_LINK = "link";

const Button = ({
    text,
    onClick,
    type = "button",
    theme = BUTTON_THEME_LINK
}) => {
    return (
        /* eslint-disable react/button-has-type */
        <button
            className={ styles[theme] }
            type={ type }
            onClick={ onClick }
        >
            { text }
        </button>
        /* eslint-enable react/button-has-type */
    );
};

Button.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    type: PropTypes.string,
    theme: PropTypes.string
};

export default Button;
